// Responsive src/srcSet for article, stock and product images (served as WebP, sized for display width).
const WIDTHS = [480, 800, 1200];
const PRODUCT_WIDTHS = [400, 800];

const variant = (url, w) => {
  if (url.includes("/api/media/")) return `${url.split("?")[0]}?w=${w}`;
  if (url.includes("images.unsplash.com")) {
    const u = new URL(url);
    u.searchParams.set("w", String(w));
    u.searchParams.set("fm", "webp");
    u.searchParams.set("q", "75");
    return u.toString();
  }
  if (/^\/(products|images)\/[^/]+\.(png|jpe?g)$/i.test(url)) return url.replace(/\.(png|jpe?g)$/i, `-${w}.webp`);
  return null;
};

export function responsiveImg(url, sizes, widths) {
  const ws = widths || (url && url.startsWith("/products/") ? PRODUCT_WIDTHS : WIDTHS);
  if (!url || !variant(url, ws[0])) return { src: url };
  return {
    src: variant(url, ws[Math.min(1, ws.length - 1)]),
    srcSet: ws.map((w) => `${variant(url, w)} ${w}w`).join(", "),
    sizes,
  };
}

// Falls back to the original file if a sized copy is missing.
export function productImg(url, sizes) {
  return {
    ...responsiveImg(url, sizes),
    onError: (e) => {
      const el = e.currentTarget;
      if (el.dataset.fellBack) { el.style.visibility = "hidden"; return; }
      el.dataset.fellBack = "1";
      el.removeAttribute("srcset");
      el.src = url;
    },
  };
}
